<template>
  <div>
    <div>
      <span class="font-weight-bold mr-1">Step Number:</span>{{ testStep.stepNumber
      }}{{ testStep.substepNumber ? `.${testStep.substepNumber}` : `` }}
    </div>
    <div>
      <span class="font-weight-bold mr-1">Scenario:</span
      ><embedded-html :data-cy="`scenario-${logId}`" :value="testStep.scenario"></embedded-html>
    </div>
    <div>
      <span class="font-weight-bold mr-1">Expected Outcome:</span>
      <embedded-html :data-cy="`expectedOutcome-${logId}`" :value="testStep.expectedOutcome"></embedded-html>
    </div>
  </div>
</template>

<script>
import EmbeddedHtml from "@/components/embeddedHtml";

export default {
  components: {
    EmbeddedHtml,
  },
  props: { logId: { required: true, type: Number }, testStep: { required: true, type: Object } },
};
</script>
